import {createRouter, createWebHashHistory} from "vue-router";
import USB from './pages/USB.vue';

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'usblicensing',
      component: USB,
      meta: {
        headerName: 'Request a license',
        tabName: 'USB Licensing',
        breadcrumb: [
          {
            name: 'Tools and Resources',
            externalLink: 'https://www.microchip.com/en-us/tools-resources',
          },
          {
            name: 'USB Licensing',
          },
        ],
        props: true,
      },
    },
  ]
});

export default router;